export default __webpack_public_path__ + "static/media/webdesign-3411373_640.d2fdd01f.jpg";